import React, { createContext, useState, useCallback } from 'react'

export const ModalContext = createContext(null)

export const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState([])

  const openModal = useCallback((Component, data) => {
    return new Promise((resolve) => {
      const id = Date.now()

      const close = (result) => {
        setModals((prev) => prev.filter((m) => m.id !== id))
        resolve(result)
      }

      setModals((prev) => [...prev, { id, Component, data, close }])
    })
  }, [])

  return (
    <ModalContext.Provider value={{ openModal }}>
      {children}
      {modals.map(({ id, Component, data, close }) => (
        <Component key={id} data={data} close={close} />
      ))}
    </ModalContext.Provider>
  )
}
